/**
 * Created by JIocb on 20.06.2017.
 */
namespace Factive.Game
{
    import Signal = Factive.Core.Signal.Signal;
    export class ScoreTableModel
    {
        private _dataProvider:Array<Object> = [];
        private _scorePredictor:ScorePredictor;
        public signal:Signal = new Signal();
        private _totalScore:number = 0;
        private _lastSelectedScore:number = -1;
        private _lock: boolean = true;

        public constructor()
        {
            this._scorePredictor = new ScorePredictor();

            this.clean();
        }

        public getDataProvider():Array<Object>
        {
            return this._dataProvider;
        }

        public predictScoresForDices(dices:Array<DiceData>,bonusMultiplier:number = 1):void
        {
            this._lastSelectedScore = -1;
            var keys = Object.keys(ScoreCombinationType)
            var l: number = keys.length * .5;
            for (var i: number = 0; i < l; i++)
            {
                var obj:any = this._dataProvider[i];
                var key:string = ScoreCombinationType[i].toLowerCase();
                var x1:number = this._scorePredictor.calculate(dices, i);
                if(!obj)
                {
                    obj = {id:i,x1:{value:x1*bonusMultiplier},x2:{value:x1*2*bonusMultiplier},x3:{value:x1*3*bonusMultiplier}};
                }
                else
                {
                    for(var j:number = 1; j<4; j++)
                    {
                        var mp = obj["x"+j.toString()];
                        if(mp.freeze!=true)
                        {
                            mp.value = x1*j*bonusMultiplier;
                        }
                    }
                }
                this._dataProvider[i] = obj;
            }

            this.onUpdated();
        }

        public unfreezeScore(scoreCombination:number,multiplier:number):void
        {
            var obj:any = this._dataProvider[scoreCombination];
            obj["x"+multiplier].freeze = false;

            this._totalScore-=obj["x"+multiplier].value;
            this.onUpdated();
        }

        public freezeScore(scoreCombination:number,multiplier:number):void
        {
            var obj:any = this._dataProvider[scoreCombination];
            obj["x"+multiplier].freeze = true;

            this._lastSelectedScore = obj["x"+multiplier].value;
            this._totalScore += this._lastSelectedScore;

            this.onUpdated();
        };

        public get numFrozenCombinations():number
        {
            var cnt:number= 0
            var l:number = this._dataProvider.length;
            for(var i:number = 0; i < l; i++)
            {
                var obj = this._dataProvider[i];

                for(var j:number = 1; j<4; j++) {
                    var mp = obj["x" + j.toString()];
                    if (mp.freeze == true)
                    {
                        cnt++;
                    }
                }
            }

            return cnt;

        }

        public set lock(value:boolean)
        {
            this._lock = value;
            this.onUpdated();
        };

        public get lock():boolean
        {
            return this._lock;
        }

        private onUpdated() {
            this.signal.dispatch("updated");
        }

        public clean()
        {
            var keys = Object.keys(ScoreCombinationType)
            var l: number = keys.length * .5;
            for (var i: number = 0; i < l; i++)
            {
                var obj:any = this._dataProvider[i];

                if(!obj)
                {
                    obj = {id:i,x1:{value:""},x2:{value:""},x3:{value:""}};
                }
                else
                {
                    for(var j:number = 1; j<4; j++)
                    {
                        var mp = obj["x"+j.toString()];
                        if(mp.freeze!=true)
                        {
                            mp.value = "";
                        }
                    }
                }
                this._dataProvider[i] = obj;
            }
            this.onUpdated();
        }

        public get totalScore():number
        {
            return this._totalScore;
        }

        public get lastSelectedScore():number
        {
            return this._lastSelectedScore;
        }

        public destroy():void
        {
            this._dataProvider = null;
            this._scorePredictor = null;
            this.signal.removeAll();
            this.signal = null;
        }


    }
}


// WEBPACK FOOTER //
// src/typescript/Game/Engine/Model/Scoring/ScoreTableModel.ts